import { render, staticRenderFns } from "./modal-block-view.vue?vue&type=template&id=37eb1742&"
import script from "./modal-block-view.vue?vue&type=script&lang=js&"
export * from "./modal-block-view.vue?vue&type=script&lang=js&"
import style0 from "./modal-block-view.vue?vue&type=style&index=0&id=37eb1742&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports